import { Box, Typography } from "@mui/material";
import { FormModalStyles } from "./FormModalStyles";
import BlackX from "@assets/svgs/x/x_black.svg";
import { CtaButton } from "@components/buttons/CtaButton";
import { useAppDispatch } from "@hooks/useTypedRedux";
import { closeModal } from "./genericModalSlice";
import { ReactNode } from "react";

interface ConfirmationModalProps {
  title: string;
  body: string | ReactNode;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

export const ConfirmationModal = ({
  title,
  body,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
}: ConfirmationModalProps) => {
  const dispatch = useAppDispatch();

  const handleConfirm = () => {
    onConfirm();
    dispatch(closeModal());
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    dispatch(closeModal());
  };

  return (
    <Box sx={FormModalStyles.modalContainer}>
      <Box sx={FormModalStyles.blackXContainer}>
        <Box
          component="img"
          src={BlackX}
          alt="Black X"
          sx={FormModalStyles.blackXBox}
          onClick={handleCancel}
        />
      </Box>
      <Typography sx={FormModalStyles.title}>{title}</Typography>
      <Box sx={FormModalStyles.scriptContainer}>
        {typeof body === "string" ? (
          <Typography sx={FormModalStyles.script}>{body}</Typography>
        ) : (
          body
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          marginTop: "20px",
          gap: "24px",
          width: "240px",
        }}
      >
        <CtaButton
          label={confirmLabel}
          onClick={handleConfirm}
          width="240px"
          height="48px"
        />
        <CtaButton
          label={cancelLabel}
          onClick={handleCancel}
          variant="secondary"
          width="240px"
          height="48px"
        />
      </Box>
    </Box>
  );
};
